module.exports = __webpack_public_path__ + "img/34.a4b9551e.png";